import { createIcon } from '@chakra-ui/react';

export const Chemistry = createIcon({
  displayName: `Chemistry`,
  viewBox: `0 0 47.054 45.188`,
  path: (
    <g transform="translate(-920.405 577.025)">
      <path
        d="M965.335-548.678v6.109l-5.29,3.054-5.29-3.054v-6.109l5.29-3.054Z"
        transform="translate(-11.479 -8.455)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M949.034-548.678v6.109l-5.29,3.054-5.29-3.054v-6.109l5.29-3.054Z"
        transform="translate(-5.746 -8.455)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M940.874-534.524v6.109l-5.29,3.054-5.29-3.054v-6.109l5.29-3.054Z"
        transform="translate(-2.877 -13.432)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M973.494-562.811v6.109l-5.29,3.054-5.29-3.054v-6.109l5.29-3.054Z"
        transform="translate(-14.348 -3.485)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="5.304"
        y1="3.054"
        transform="translate(922.112 -551.011)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="5.304"
        y2="3.054"
        transform="translate(922.112 -541.848)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="5.706"
        transform="translate(932.707 -538.794)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y1="6.425"
        transform="translate(953.856 -575.775)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="5.993"
        y2="3.43"
        transform="translate(959.146 -560.187)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y1="3.353"
        x2="6.633"
        transform="translate(959.146 -569.649)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="2.641"
        transform="translate(950.856 -555.253)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        y2="2.641"
        transform="translate(930.225 -546.294)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
